export var COLOR_ATTRIBUTE = 13;
export var CAPACITY_ATTRIBUTE = 14;
export var COLOR_RGB_ATTRIBUTE = 109;
export var TOP_SMARTPHONE_ATTRIBUTE = 185;
export var TOP_FEATURES_ATTRIBUTE = 143;
export var INTERNAL_STORAGE_ATTRIBUTE = 14;
export var WATER_RESISTANT_ATTRIBUTE = 157;
export var CARDREADER_ATTRIBUTE = 97;
export var SIMCARDTYPE_ATTRIBUTE = 99;
export var OLS_LAUNCHDATE_ATTRIBUTE = 164;
export var FOR_SENIORS_ATTRIBUTE = 158;
export var DISPLAY_SIZE_ATTRIBUTE = 57;
export var CAMERA_MP_ATTRIBUTE = 47;
export var IMAGE_SHOWCASE_ATTRIBUTE = 159;
export var BUNDLE_ATTRIBUTE = 223;
export var BUNDLE_DESCRIPTION_ATTRIBUTE = 142;
var ProductAttributeDescription = /*@__PURE__*/ (function () {
    function ProductAttributeDescription(data) {
        if (data) {
            if (data.id) {
                this.id = parseInt(data.id, 10);
            }
            if (data.groupId) {
                this.groupId = parseInt(data.groupId, 10);
            }
            if (data.hidden) {
                this.hidden = data.hidden.toLowerCase() === 'true';
            }
            if (data.sortOrder) {
                this.sortOrder = parseInt(data.sortOrder, 10);
            }
            if (data.label) {
                this.label = data.label;
            }
            if (data.mask) {
                this.mask = data.mask;
            }
            if (data.description) {
                this.description = data.description;
            }
            if (data.unit) {
                this.unit = data.unit;
            }
        }
    }
    return ProductAttributeDescription;
}());
export { ProductAttributeDescription };
var ProductAttribute = /*@__PURE__*/ (function () {
    function ProductAttribute(data) {
        if (data) {
            if (data.id) {
                this.id = parseInt(data.id, 10);
            }
            if (data.sortOrder) {
                this.sortOrder = parseInt(data.sortOrder, 10);
            }
            if (data.value) {
                this.value = data.value;
            }
            if (data.description) {
                this.description = data.description;
            }
        }
    }
    return ProductAttribute;
}());
export { ProductAttribute };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/product/product.attribute.ts
// module id = null
// module chunks = 